import { callRestApi } from '@hooks/useRestApi'

const SERVICE_URLS = {
  STOCK_NOTIFY_REQUEST: '/product/stocknotify',
  PRODUCT_DELIVERY_DATES: '/product/delivery_dates',
}

const stockNotifyRequest = async (data: {
  data: { sku: string; email: string }
}) => {
  return callRestApi(SERVICE_URLS.STOCK_NOTIFY_REQUEST, 'post', data)
}

const productDeliveryDates = (data: {
  data: { sku: string; destinationZipcode: string }
}) => {
  return callRestApi(SERVICE_URLS.PRODUCT_DELIVERY_DATES, 'post', data)
}

const pdpService = {
  stockNotifyRequest,
  productDeliveryDates,
}

export default pdpService
